export enum InlineMessageAligment {
  left = 'left',
  right = 'right',
  center = 'center',
}

export enum InlineMessageVariant {
  info = 'info',
  success = 'success',
  warning = 'warning',
  error = 'error',
}

export const ICON_NAME_MAP = {
  [InlineMessageVariant.info]: 'info-purple-icon',
  [InlineMessageVariant.success]: 'success-green-icon',
  [InlineMessageVariant.warning]: 'warning-yellow-icon',
  [InlineMessageVariant.error]: 'error-red-icon',
};
